import { parseOptional, parseDate } from "@syla/shared/types/helpers/parsing";
import { TransportType } from "@syla/shared/types/helpers/TransportType";
import axios from "axios";

import { User } from "../../types/user/user";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function getUser(): Promise<User> {
  let data: TransportType<User>;
  try {
    const response = await axios.get<TransportType<User>>("/users");
    data = response.data;
  } catch (error) {
    throwSylaApiError(error);
  }

  return {
    ...data,
    createdAt: parseOptional(data.createdAt, parseDate),
    updatedAt: parseOptional(data.updatedAt, parseDate),
  };
}
